export default "__VITE_ASSET__CNvgAY6N__"